// api
import type {
  MatrikelDataPoint,
  MatrikelOverwritePatchInput,
} from '@/api/generated/energyAnalysis/endpoints/portfolioAnalysisMatrikel';

// relative
import type { EditMatrikelBuildingFormValues } from './editMatrikelBuildingForm.schema';

const round0 = (v: number | null | undefined): number | null =>
  v == null ? null : Math.round(v);

/** Resolves effective values, preferring Overwrite* fields when OverwriteFlag is set. */
export function toEditMatrikelBuildingFormValues(
  dto?: MatrikelDataPoint,
): EditMatrikelBuildingFormValues {
  const useOverwrite = dto?.OverwriteFlag ?? false;
  return {
    averageBuildingYear: useOverwrite
      ? round0(dto?.OverwriteAverageBuildingYear ?? dto?.AverageBuildingYear)
      : round0(dto?.AverageBuildingYear),
    sumBuildingArea: useOverwrite
      ? round0(dto?.OverwriteSumBuildingArea ?? dto?.SumBuildingArea)
      : round0(dto?.SumBuildingArea),
    extractedBuildingUse: useOverwrite
      ? (dto?.OverwriteExtractedBuildingUse ?? dto?.ExtractedBuildingUse ?? '')
      : (dto?.ExtractedBuildingUse ?? ''),
    extractedHeatInstallation: useOverwrite
      ? (dto?.OverwriteExtractedHeatInstallation ??
        dto?.ExtractedHeatInstallation ??
        '')
      : (dto?.ExtractedHeatInstallation ?? ''),
    verificationFlag: dto?.VerificationFlag ?? false,
  };
}

/** Returns the raw BBR values (ignoring any overwrite). Used for diff comparison and reset. */
export function toBBRFormValues(
  dto?: MatrikelDataPoint,
): EditMatrikelBuildingFormValues {
  return {
    averageBuildingYear: round0(dto?.AverageBuildingYear),
    sumBuildingArea: round0(dto?.SumBuildingArea),
    extractedBuildingUse: dto?.ExtractedBuildingUse ?? '',
    extractedHeatInstallation: dto?.ExtractedHeatInstallation ?? '',
    verificationFlag: dto?.VerificationFlag ?? false,
  };
}

/** Maps form values to the patch DTO. Empty string selects are sent as null. */
export function toMatrikelOverwritePatchInput(
  values: EditMatrikelBuildingFormValues,
): MatrikelOverwritePatchInput {
  return {
    AverageBuildingYear: values.averageBuildingYear,
    SumBuildingArea: values.sumBuildingArea,
    ExtractedBuildingUse: values.extractedBuildingUse || null,
    ExtractedHeatInstallation: values.extractedHeatInstallation || null,
    OverwriteFlag: true,
    VerificationFlag: values.verificationFlag,
  };
}
